import { NeoNamespace } from '../common-enum';

export enum DebugLevel {
  Info = 1,
  Warn,
  Error,
}

export interface DebugConfig {
  level: DebugLevel;
  namespace: NeoNamespace[];
}

const debugConfig: DebugConfig = {
  level: DebugLevel.Info,
  namespace: [],
};

/**
 * 是否允许 debug
 * @param {NeoNamespace} namespace 模块命名空间
 * @param {DebugLevel} level debug 级别
 */
function allowDebug(namespace: NeoNamespace, level: DebugLevel): boolean {
  if (debugConfig.level > level) {
    return false;
  }
  if (
    debugConfig.namespace.length &&
    debugConfig.namespace.indexOf(namespace) === -1
  ) {
    return false;
  }
  return true;
}

/**
 * debug 函数
 * @param {NeoNamespace} namespace 模块命名空间
 * @param {DebugLevel} level debug 级别
 * @param {any[]} restArgs debug 变量
 */
export function debug(
  namespace: NeoNamespace,
  level: DebugLevel,
  ...restArgs: any[]
): void {
  if (process.env.NODE_ENV !== 'production') {
    if (!allowDebug(namespace, level)) {
      return;
    }

    switch (level) {
      case DebugLevel.Info:
        // eslint-disable-next-line no-console
        console.log(namespace, restArgs);
        break;
      case DebugLevel.Warn:
        // eslint-disable-next-line no-console
        console.warn(namespace, restArgs);
        break;
      case DebugLevel.Error:
        // eslint-disable-next-line no-console
        console.error(namespace, restArgs);
        break;
      default:
    }
  }
}

/**
 * 设置 debug 配置
 * @param {DebugConfig} config debug 配置
 */
export function setDebugConfig(config: DebugConfig) {
  debugConfig.level = config.level;
  debugConfig.namespace = config.namespace;
}
